<div *ngIf="state.open" class="backdrop animated fadeIn" [class.open]="state.open" (click)="dismiss()">&nbsp;</div>

<div class="sidebar" [class.open]="state.open">
  <ng-container *ngIf="element && visible">

   <div class="header animated fadeIn">
      <mat-toolbar color="primary">
        <span>{{ element.name }}</span>
        <mat-icon (click)="dismiss()">close</mat-icon>
      </mat-toolbar>
    </div>

    <div class="content animated fadeIn">
      <mat-tab-group [selectedIndex]="state.tab" (selectedTabChange)="onTabChange($event)" fxFlex>

        <!-- Overview -->
        <mat-tab [disabled]="routerService.isElementDetailPage()">
          <ng-template matTabLabel>
            <mat-icon>subject</mat-icon>
            {{ 'detail' | translate: 'plural' }}
          </ng-template>
          <ng-template matTabContent>
            <div class="wrapper" fxFlex="grow" fxLayout="column">
              <div class="body">
                <sg2-element-form 
                  [element]="element"
                  [elementFormControls]="formControls"
                  [mode]="state.mode"
                  display="column">
                </sg2-element-form>
              </div>
              <div class="footer" fxFlex>
                <sg2-element-form-controls></sg2-element-form-controls>
              </div>
            </div>
          </ng-template>
        </mat-tab>

        <!-- Logs -->
        <mat-tab [disabled]="state.mode === 'create'">
          <ng-template matTabLabel>
            <mat-icon>comment</mat-icon>
            {{ 'comment' | translate: 'plural' }}
          </ng-template>
          <ng-template matTabContent>
            <div class="wrapper" fxFlex="grow" fxLayout="column">
              <div id="element-sidebar-comments" class="body">
                <sg2-element-logs-item *ngFor="let comment of comments" [log]="comment"></sg2-element-logs-item>
              </div>
              <div class="footer" fxFlex>
                <sg2-element-logs-comment-box [element]="element"></sg2-element-logs-comment-box>
              </div>
            </div>
          </ng-template>
        </mat-tab>

        <!-- History -->
        <mat-tab [disabled]="state.mode === 'create'">
          <ng-template matTabLabel>
            <mat-icon>history</mat-icon>
            {{ 'history' | translate }}
          </ng-template>
          <ng-template matTabContent>
            <div class="wrapper" fxFlex="grow" fxLayout="column">
              <div class="body">
                <sg2-element-logs-item *ngFor="let change of changes" [log]="change"></sg2-element-logs-item>
              </div>
            </div>
          </ng-template>
        </mat-tab>

      </mat-tab-group>

    </div>

  </ng-container>
</div>
